import { DigitalLender } from '@/shared/api/types';

/**
 * Checks if two company names match either exactly or via a case-insensitive starts-with check in either direction.
 */
export function isPartialNameMatch(nameA: string, nameB: string): boolean {
  if (!nameA || !nameB) return false;
  const lowerA = nameA.toLowerCase().trim();
  const lowerB = nameB.toLowerCase().trim();
  return (
    lowerA === lowerB ||
    lowerA.startsWith(lowerB) ||
    lowerB.startsWith(lowerA)
  );
}

/**
 * Returns the first entry from `list` whose `creditor` field matches
 * `name` either exactly or via a case-insensitive starts-with check in
 * either direction. This handles cases where Inbest returns a shorter
 * name (e.g. "Severn Trent") while the master list holds the full name
 * ("Severn Trent Water Ltd"), and vice-versa.
 */
export function findFreepostByPartialName(
  list: DigitalLender[],
  name: string,
): DigitalLender | undefined {
  if (!name) return undefined;
  return list.find((entry) => isPartialNameMatch(entry.creditor, name));
}
